import { render, staticRenderFns } from "./ListEventsOnProperty.vue?vue&type=template&id=b6c16c96&scoped=true&"
import script from "./ListEventsOnProperty.vue?vue&type=script&lang=js&"
export * from "./ListEventsOnProperty.vue?vue&type=script&lang=js&"
import style0 from "./ListEventsOnProperty.vue?vue&type=style&index=0&id=b6c16c96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c16c96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VIcon,VSimpleTable})
